module.exports = __webpack_public_path__ + "img/section-title2.b472c8e6.png";